"use client";

import React, { useEffect, useRef, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ArrowRight, Play, Users } from "lucide-react";
export default function TheIntelligenceGateway() {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const [userCount, setUserCount] = useState(12453);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;
    let width = canvas.width = window.innerWidth;
    let height = canvas.height = window.innerHeight;
    let animationFrameId: number;
    const nodes: {
      x: number;
      y: number;
      vx: number;
      vy: number;
    }[] = [];
    const nodeCount = Math.floor(width * height / 15000);
    const connectionDistance = 150;
    for (let i = 0; i < nodeCount; i++) {
      nodes.push({
        x: Math.random() * width,
        y: Math.random() * height,
        vx: (Math.random() - 0.5) * 0.5,
        vy: (Math.random() - 0.5) * 0.5
      });
    }
    const draw = () => {
      ctx.clearRect(0, 0, width, height);
      nodes.forEach((node, i) => {
        node.x += node.vx;
        node.y += node.vy;
        if (node.x < 0 || node.x > width) node.vx *= -1;
        if (node.y < 0 || node.y > height) node.vy *= -1;
        ctx.beginPath();
        ctx.arc(node.x, node.y, 2, 0, Math.PI * 2);
        ctx.fillStyle = "hsla(197, 73%, 52%, 0.5)";
        ctx.fill();
        for (let j = i + 1; j < nodes.length; j++) {
          const other = nodes[j];
          const dx = node.x - other.x;
          const dy = node.y - other.y;
          const distance = Math.sqrt(dx * dx + dy * dy);
          if (distance < connectionDistance) {
            ctx.beginPath();
            ctx.moveTo(node.x, node.y);
            ctx.lineTo(other.x, other.y);
            const opacity = 1 - distance / connectionDistance;
            ctx.strokeStyle = `hsla(197, 73%, 52%, ${opacity * 0.2})`;
            ctx.stroke();
          }
        }
      });
      animationFrameId = requestAnimationFrame(draw);
    };
    const handleResize = () => {
      width = canvas.width = window.innerWidth;
      height = canvas.height = window.innerHeight;
    };
    window.addEventListener("resize", handleResize);
    draw();
    return () => {
      window.removeEventListener("resize", handleResize);
      cancelAnimationFrame(animationFrameId);
    };
  }, []);
  useEffect(() => {
    const interval = setInterval(() => {
      setUserCount(prev => prev + Math.floor(Math.random() * 3) - 1);
    }, 3000);
    return () => clearInterval(interval);
  }, []);
  return <section data-section-id="16245" id="scale-your-smb-with-ai" className="bg-background text-foreground relative min-h-screen w-full overflow-hidden flex flex-col items-center justify-center py-20 px-4">
      {}
      <canvas ref={canvasRef} className="absolute inset-0 z-0 pointer-events-none opacity-40" />

      {}
      <div className="relative z-10 flex flex-col items-center text-center max-w-5xl mx-auto space-y-10">
        
        {}
        <h1 className="text-5xl md:text-7xl lg:text-[80px] font-default font-bold leading-tight tracking-tight text-[#222222]">
          Scale Your SMB with <br className="hidden md:block" />
          <span className="bg-gradient-to-r from-[#28AADE] to-[#007EB0] bg-clip-text text-transparent">
            AI-Powered Precision
          </span>
        </h1>

        {}
        <p className="text-lg md:text-[20px] text-muted-foreground max-w-[600px] leading-relaxed font-default">
          Empowering small and medium businesses with surgical AI solutions. 
          Your partner in operational intelligence and growth starts here.
        </p>

        {}
        <div className="flex flex-col sm:flex-row items-center gap-6 w-full sm:w-auto">
          <Button asChild size="lg" className="h-14 px-8 text-lg rounded-sm bg-[#28AADE] text-white hover:bg-[#259CCC] shadow-sm transition-all duration-300 font-default font-semibold">
            <Link to="#">
              Start Free Audit <ArrowRight className="ml-2 size-5" />
            </Link>
          </Button>

          <Button asChild variant="outline" size="lg" className="h-14 px-8 text-lg rounded-sm border-[#007EB0] text-[#007EB0] hover:bg-[#F0FAFF] hover:border-[#007EB0] backdrop-blur-sm transition-all duration-300 font-default font-semibold">
            <Link to="#">
              <Play className="mr-2 size-5 fill-current" /> Explore Solutions
            </Link>
          </Button>
        </div>

        {}
        <div className="pt-4 animate-in fade-in slide-in-from-bottom-4 duration-1000 delay-300">
          <Badge variant="secondary" className="px-4 py-2 rounded-sm bg-[#F0FAFF] border border-[#28AADE]/30 text-[#222222] backdrop-blur-md gap-2">
            <span className="relative flex h-2.5 w-2.5">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#28AADE] opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-[#28AADE]"></span>
            </span>
            <span className="font-mono font-medium tracking-wide">
              {userCount.toLocaleString()}
            </span>
            <span className="text-muted-foreground text-xs uppercase tracking-wider ml-1">
              Active Clients
            </span>
          </Badge>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-background to-transparent pointer-events-none z-10" />
    </section>;
}